import ReactDOM from 'react-dom/client'
import i18n from "./i18n";
import {
  registerTechDiscTranslations,
  TechDisc,
} from "@moilanenmime/throwdataanalyzer";

registerTechDiscTranslations(i18n);

import '@moilanenmime/throwdataanalyzer/style.css'

const el = document.getElementById('techdisc-app')
const locale = el ? el.getAttribute('data-locale') : 'en';

if (el) {
  console.log('TechDisc app initialized with locale:', locale)

    ReactDOM.createRoot(el).render(
        <TechDisc language={locale} />
    )
}
